import { LANGUAGES } from "@/i18n";

export const LangSwitcher = ({ lang, setLang }) => (
  <div className="flex items-center gap-1 text-[10px] font-mono-lbl uppercase tracking-[0.14em]" data-testid="lang-switcher">
    {LANGUAGES.map((l, i) => (
      <span key={l.code} className="flex items-center">
        {i > 0 && <span className="text-[#4d1a2a] mx-1">/</span>}
        <button
          type="button"
          data-testid={`lang-${l.code}`}
          onClick={() => setLang(l.code)}
          className={lang === l.code ? "text-[#d3b870] font-bold" : "text-[#b4939c] hover:text-[#d3b870] transition-colors"}
        >
          {l.label}
        </button>
      </span>
    ))}
  </div>
);
